import { InboxReducerState } from './types';

export const initialState: InboxReducerState = {
  filters: {
    order: 'asc',
    orderBy: 'date',
    query: '',
  },
};
